<template>
    <section class="container">
      <slot></slot>
    </section>

</template>
  
<script>
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.container{
  display: flex;
  width: 100%;
  min-height: 90vh;
  background-color: #faf3e1;
}        
</style>